import { formatSquaresAvailableAt } from '../../utils/formatSquaresAvailableAt';

export interface SquaresAvailableAtLineProps {
  /** ISO timestamp for when the squares grid opens, or null */
  questionsPostedAt: string | null | undefined;
  /** data-test-id for the rendered line */
  testId: string;
}

/**
 * "Squares will be available <date>" line shown during the reserve window
 * (DKPLAT-529). Shared by ReservePanel and SeatReservedModal so both render the same
 * copy and date format. Renders nothing when there is no reserve window.
 */
export default function SquaresAvailableAtLine({
  questionsPostedAt,
  testId,
}: SquaresAvailableAtLineProps) {
  const label = formatSquaresAvailableAt(questionsPostedAt);
  if (!label) return null;

  return (
    <p data-test-id={testId} className="text-sm font-semibold text-yellow-500">
      Squares will be available {label}
    </p>
  );
}
